import { EActivityCategories } from '@/domain/Activities.domain';
import { AvailabilityInfo } from './AvailabilityInfo';
import { CallToBook } from './CallToBook';
import { categoryImages } from '../data';
import { TAvailItem } from '@/service/state/FullCalendar/domain';
import { cn } from '@/service/utils/cn';

type TCalendarCardProps = {
    schedule: TAvailItem;
    isActive: boolean;
    index?: number;
    selectColumn: () => void;
};

const setAnimation = (index?: number) => {
    if (!index) {
        return 'animate-duration-1';
    }
    if (index === 1) {
        return 'animate-duration-2';
    }
    if (index === 2) {
        return 'animate-duration-3';
    }
    if (index === 3) {
        return 'animate-duration-4';
    }
    if (index === 4) {
        return 'animate-duration-3';
    }
    if (index === 5) {
        return 'animate-duration-2';
    }
    /*     if(index === 6){
        return 'animate-duration-2';
    };
    if(index === 7){
        return 'animate-duration-3';
    };
    if(index === 8){
        return 'animate-duration-4';
    };
    if(index === 9){
        return 'animate-duration-5';
    }; */

    return 'animate-duration-1';
};

export const CalendarCard = ({ schedule, isActive, selectColumn, index }: TCalendarCardProps) => {
    const time = schedule.time?.split(/(?=[ap]m)/i);

    return (
        <div
            data-test-id="calendar-card"
            className={cn(
                'relative my-3 flex w-full gap-x-4 md:animate-none md:gap-x-[5px]',
                setAnimation(index)
            )}
        >
            <div className="tx-large-semibold mt-3 flex w-max flex-col gap-[6px] whitespace-pre-wrap text-state-info md:tx-large-semibold md:gap-[5px]">
                {!!time && (
                    <div className={`text-center`} data-test-id="calendar-card-time">
                        <p className="leading-[12px]">{time[0]}</p>
                        <p className="leading-[12px]">{time[1]}</p>
                    </div>
                )}
                <div
                    data-test-id="calendar-card-icon"
                    className={`flex h-[50px] w-[50px] items-center justify-center bg-contain bg-no-repeat md:h-8 md:w-8 ${
                        categoryImages[schedule.icon as EActivityCategories] ||
                        categoryImages[EActivityCategories.WAVE]
                    }`}
                />
            </div>
            <button
                type="button"
                className={`flex min-h-[104px] w-full max-w-[268px] flex-col gap-4 rounded-[15px] px-6 py-4 md:min-h-[80px] md:max-w-[284px] md:px-3 md:pb-4 md:pt-2 ${
                    !schedule.call_to_booking
                        ? `${
                              isActive
                                  ? 'bg-brand shadow-active dark:shadow-none'
                                  : 'bg-blue-9 dark:bg-blue-1'
                          }`
                        : 'bg-red-3 dark:bg-red-5'
                }`}
                onClick={selectColumn}
            >
                <p
                    data-test-id="calendar-schedule-name"
                    className={`w-56 text-left text-base font-semibold leading-snug dark:text-white md:w-full md:text-sm ${
                        isActive ? 'text-white' : 'text-gray-1'
                    }`}
                >
                    {schedule.name}
                </p>
                {!schedule.call_to_booking ? (
                    <AvailabilityInfo
                        ticketsAvail={schedule.tickets?.avail || 0}
                        className="w-auto"
                        data-test-id=""
                    />
                ) : (
                    <CallToBook />
                )}
            </button>
        </div>
    );
};
